import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, today, fmtDate } from "@/lib/api";
import { Section } from "@/components/Fields";

const CloseDialog = ({ mode, onClose, pid, onDone }) => {
  const [motivo, setMotivo] = useState("");
  const [fecha, setFecha] = useState(today());
  const submit = async () => {
    await api.post(`/patients/${pid}/${mode}`, { motivo, fecha });
    toast.success(mode === "alta" ? "Alta registrada y protocolo creado" : "Baja registrada");
    onClose();
    onDone();
  };
  return (
    <Dialog open={!!mode} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="close-dialog">
        <DialogHeader><DialogTitle className="font-[Outfit]">{mode === "alta" ? "Dar de alta" : "Dar de baja"}</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">{mode === "alta" ? "Los tratamientos activos se marcarán como finalizados y se programarán las revisiones del protocolo de alta (1, 3, 6 y 12 meses)." : "Los tratamientos activos se marcarán como baja."}</p>
        {mode === "alta" && <Input type="date" data-testid="close-fecha" value={fecha} onChange={(e) => setFecha(e.target.value)} />}
        <Input data-testid="close-motivo" placeholder={mode === "alta" ? "Nota (opcional)" : "Motivo (abandono, precio…)"} value={motivo} onChange={(e) => setMotivo(e.target.value)} />
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button data-testid="close-confirm" onClick={submit} className={mode === "alta" ? "bg-teal-600 hover:bg-teal-700" : "bg-rose-600 hover:bg-rose-700"}>Confirmar</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const CloseActions = ({ patient, alta, onDone }) => {
  const [mode, setMode] = useState(null);
  const reabrir = async () => {
    await api.post(`/patients/${patient.id}/reabrir`);
    toast.success("Paciente reabierto");
    onDone();
  };
  return (
    <Section title="Cierre" testId="sec-cierre">
      {patient.cierre ? (
        <div className="space-y-3 text-sm">
          <p className="text-slate-600">Paciente en <b>{patient.cierre === "alta" ? "alta" : "baja"}</b>{patient.motivo_cierre && ` · ${patient.motivo_cierre}`}</p>
          {alta && <Link to="/altas" className="text-[#1E3A8A] underline text-sm" data-testid="link-protocolo-alta">Ver protocolo de alta ({fmtDate(alta.fecha_alta)})</Link>}
          <Button variant="outline" size="sm" data-testid="reabrir-btn" onClick={reabrir}>Reabrir paciente</Button>
        </div>
      ) : (
        <div className="flex gap-2">
          <Button data-testid="alta-btn" onClick={() => setMode("alta")} className="bg-teal-600 hover:bg-teal-700 flex-1">Dar de alta</Button>
          <Button data-testid="baja-btn" variant="outline" onClick={() => setMode("baja")} className="flex-1 text-rose-700 border-rose-200 hover:bg-rose-50">Dar de baja</Button>
        </div>
      )}
      <CloseDialog mode={mode} pid={patient.id} onClose={() => setMode(null)} onDone={onDone} />
    </Section>
  );
};
